import { IFormValues } from '@scentregroup/shared/hooks/use-form'

export const ERROR_EMAIL_INVALID = 'Please enter a valid email address'
export const ERROR_MOBILE_INVALID = 'Please enter a valid mobile number'
export const ERROR_PASSWORD_REQUIRED = 'Please provide a password'
export const ERROR_PASSWORD_INVALID = `Please enter a password that is at least 8 characters long.
                    It must contain both capital and lower case letters
                    and at least 1 number`

export enum TermsAndConditionslocation {
  CART = '/shop/westfield-digital-gift-card/cart',
  CHECKOUT = '/shop/westfield-digital-gift-card/checkout',
}

export type ITermsAndConditions = [
  string,
  TermsAndConditionslocation | undefined,
]

export const isEmpty = (value: string | undefined): value is undefined => {
  return !(value && value.length)
}

/**
 * Requirements:
 * - 8 characters
 * - an upper case letter
 * - a lower case letter
 * - a number
 */
const MIN_PASSWORD_LENGTH = 8
export const isValidPassword = (password: string): boolean =>
  password.length >= MIN_PASSWORD_LENGTH &&
  password !== password.toLowerCase() &&
  password !== password.toUpperCase() &&
  /[0-9]/.test(password)

export const emptyErrorMessage = (
  value: string | undefined,
  fieldName: string,
  action?: string
): string | undefined => {
  if (!isEmpty(value)) return undefined

  const errorMessage = `Please ${action || 'enter'} a ${fieldName}`
  return errorMessage
}

export const validateAustralianPostcode = (
  postcode: string | undefined
): string | undefined => {
  if (!/^\d{4}$/.test(postcode?.trim() || '')) {
    return 'Please enter a valid postcode'
  }
  return undefined
}

export const validateGlobalPostcode = (
  postcode: string | undefined
): string | undefined => {
  if (!postcode || postcode.trim().length < 3) {
    return 'Please enter a valid postcode'
  }
  return undefined
}

export const validateEmail = (
  value: string | undefined
): string | undefined => {
  if (isEmpty(value)) {
    return ERROR_EMAIL_INVALID
  }

  const reg =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (reg.test(value)) {
    return undefined
  }

  return ERROR_EMAIL_INVALID
}

export const validateMobile = (
  value: string | undefined
): string | undefined => {
  if (isEmpty(value)) {
    return ERROR_MOBILE_INVALID
  }

  const reg = /^[0-9]{8,10}$/

  if (reg.test(value)) {
    return undefined
  }

  return ERROR_MOBILE_INVALID
}

export const validatePassword = (
  value: string | undefined
): string | undefined => {
  if (isEmpty(value)) {
    return ERROR_PASSWORD_REQUIRED
  }

  if (!isValidPassword(value)) {
    return ERROR_PASSWORD_INVALID
  }

  return undefined
}

export const getValidationRequiredFunction =
  <T>(values: IFormValues<T>, isSubmitting?: boolean) =>
  (key: string) => {
    return isSubmitting || key in values
  }
